import OrderList, { IProps as OrderListProps } from "../OrderList";
import Pagination, { IProps as PaginationProps } from "../Navigation/Pagination";
import React from "react";

interface IProps extends OrderListProps, PaginationProps {}

const PaginatedOrderList = (props: IProps) => {
  const { loading, error, orders, onPageChange, onPerPageChange, total, perPage, currentPage, onOrderChange } = props;

  return (
    <div className="paginated-order-list">
      <OrderList
        orders={orders}
        loading={loading}
        error={error}
        onOrderChange={onOrderChange}
      />
      {
        total > 0 &&
        <Pagination
          currentPage={currentPage}
          total={total}
          perPage={perPage}
          onPageChange={onPageChange}
          onPerPageChange={onPerPageChange}
        />
      }
    </div>
  )

}

export default PaginatedOrderList;
